/*
 * @Author: 吴雪
 * @Date: 2021-10-11 15:32:41
 * @Last Modified by: xuewu@wholeeprime.com
 * @Last Modified time: 2021-12-08 19:56:30
 */
import ProductList from './component-product-list_v1.js';
import { appendProducts, refreshProducts } from './product-list-utils_v6.js';

class FeaturedCollection extends ProductList {
  constructor() {
    super();
    this.url = apiHost+'/gw/gm-view/shopify/cards/v2/getCollectionCards';
    Object.assign(this.ajaxData, {pageNo: 1, handle: "all"});
    this.fetchData(this.ajaxData, this.url, (results) => {
      refreshProducts(this.wrapperEle, results, { show_title: this.showTitle, show_color_swatch: this.showColorSwatch});
    })
  }

  loadMoreClickHandler (e) {
    e.stopPropagation();
    this.fetchData({
      ...this.ajaxData,
      pageNo: this.ajaxData.pageNo + 1
    }, this.url, (results) => {
      appendProducts(this.wrapperEle, results, { show_title: this.showTitle, show_color_swatch: this.showColorSwatch});
    })
  }
}

customElements.define('featured-collection', FeaturedCollection);
